<template>
  <TransitionFade>
    <div class="app-top-bar" v-if="show">
      <div class="bar-container">
        <div class="bar-section">
          <div class="logo-container">
            <Logo color="white"/>
            <span>Data+Analytics</span>
          </div>
        </div>
      </div>
    </div>
  </TransitionFade>
</template>

<script setup>
import {computed} from "vue";
import {useStore} from "vuex";
import TransitionFade from "@/components/TransitionFade";
import Logo from "@/components/Logo.vue";

const store = useStore();


const show = computed(() => store.state.auth.token);
</script>

<style scoped lang="less">
@import "@/assets/theme-vars";

@transition_duration: .5s;

.app-top-bar {
  background-color: @blackish;
  color: @white;
  width: 100%;
  flex: 0 1 0;
  position: relative;

  .bar-container {
    width: 100%;

    .bar-section {
      flex: 1 0 0;

      .logo-container {
        justify-content: start;
        align-items: start;
        padding: 1rem;
        flex-direction: column;

        embed {
          height: 3rem;
        }

        span {
          align-self: center;
        }
      }

      &.options {
        justify-content: end;
        align-items: center;
        margin: 1rem;
        font-size: 2rem;
        gap: 3rem;

        a {
          color: white;
          font-size: 1rem;
        }

      }

      .options-container {
        justify-content: end;
        align-items: center;
        margin: .5rem 2rem .5rem .5rem;
      }
    }
  }

  .menu {
    position: absolute;
    right: 0;
    top: calc(100%);
    display: grid;
    z-index: @menu_z_index;

    .menu-item {
      padding: .5rem;
      border: 1px solid @gray;
      background-color: @blackish;
      color: @whitish;
    }
  }

  .menu-close-detect {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, .5);
    z-index: @menu_close_z_index;
  }
}


</style>